/* Petrix — בונה קערת דונאט (11.10.2026). שכבות תמונה לפי צבע לכל קומה + line item properties. */
(() => {
  if (customElements.get('petrix-donut-builder')) return;
  const store = (window.__petrixDonut = window.__petrixDonut || {});

  class PetrixDonutBuilder extends HTMLElement {
    connectedCallback() {
      let cfg;
      try { cfg = JSON.parse(this.querySelector('script[type="application/json"]').textContent); } catch (e) { return; }
      this.cfg = cfg;
      // הבחירה נשמרת ב-window כי התבנית מחליפה את הבלוק בכל החלפת מידה
      const key = this.dataset.pid;
      this.st = store[key] || (store[key] = cfg.defaults.slice());
      this.querySelectorAll('input[type=radio][data-tier]').forEach((r) => {
        r.checked = this.st[+r.dataset.tier - 1] === r.value;
        r.addEventListener('change', () => { if (r.checked) this.pick(+r.dataset.tier, r.value); });
      });
      this.render();
      const warm = () => {
        if (this.warmed) return; this.warmed = true;
        Object.values(cfg.layers).forEach((m) => Object.values(m).forEach((u) => { const i = new Image(); i.decoding = 'async'; i.src = u; }));
      };
      this.addEventListener('pointerdown', warm, { once: true });
      this.addEventListener('focusin', warm, { once: true });
      // שאר השכבות (~0.8MB) נטענות רק כשהלקוח מתחיל לבחור, כדי לא להכביד על טעינת הדף
      this.addEventListener('pointerenter', warm, { once: true });
    }

    pick(tier, key) {
      if (!this.cfg.colors[key]) return;
      this.st[tier - 1] = key;
      this.render();
    }

    render() {
      const { colors, layers } = this.cfg;
      const names = [];
      [1, 2, 3].forEach((t) => {
        const key = this.st[t - 1];
        const c = colors[key]; if (!c) return;
        names[t] = c.he;
        const img = this.querySelector(`img[data-layer="${t}"]`);
        const url = layers[t][key];
        if (img && img.getAttribute('src') !== url) {
          const pre = new Image(); pre.src = url;
          const swap = () => { if (this.st[t - 1] === key) img.src = url; };
          (pre.decode ? pre.decode() : Promise.resolve()).then(swap, swap);
        }
        const nm = this.querySelector(`[data-pdb-name="${t}"]`); if (nm) nm.textContent = c.he;
        const prop = this.querySelector(`[data-pdb-prop="${t}"]`); if (prop) prop.value = c.he;
      });
      const code = this.querySelector('[data-pdb-code]'); if (code) code.value = this.st.join('-');
      const stage = this.querySelector('[data-pdb-stage]');
      if (stage) stage.setAttribute('aria-label', `קערה בצבעים: קומה עליונה ${names[3]}, קומה אמצעית ${names[2]}, קומה תחתונה ${names[1]}`);
    }
  }
  customElements.define('petrix-donut-builder', PetrixDonutBuilder);
})();
